/**
 * «Sitio web» con o sin `http://`: la persona escribe o pega lo que tenga y el campo se queda con la forma que
 * acepta el documento (sin protocolo; el guardián «sin red» del PDF no deja pasar `http`, `https` ni `//`).
 * Sólo se limpia el protocolo del comienzo; el resto no se toca (ni mayúsculas ni la ruta).
 */
export function limpiarWeb(v: string): string {
  return v.replace(/^\s*(?:https?:)?\/\//i, '');
}
